export default {"src":"/_next/static/media/usa-today.8496f74d.svg","height":32,"width":90,"blurWidth":0,"blurHeight":0};